import { render, staticRenderFns } from "./PagePlaceholder.vue?vue&type=template&id=7238fd4f"
import script from "./PagePlaceholder.vue?vue&type=script&lang=js"
export * from "./PagePlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports